import { render, staticRenderFns } from "./credit-memo-state-summary.vue?vue&type=template&id=2bc61988&"
import script from "./credit-memo-state-summary.vue?vue&type=script&lang=js&"
export * from "./credit-memo-state-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports